import { jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setVideoId } from "./../../store/reducers/videoReducer.js";
const VideoModal = () => {
  const { videoId } = useSelector((state) => state.video);
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setVideoId(null));
  };
  const embedUrl = useMemo(
    () => `https://www.youtube.com/embed/${videoId}?autoplay=1`,
    [videoId]
  );
  return /* @__PURE__ */ jsx(
    Modal,
    {
      open: !!videoId,
      onCancel: handleClose,
      footer: null,
      centered: true,
      width: 800,
      styles: {
        content: {
          padding: 0,
          borderRadius: 0,
          aspectRatio: "16/9"
        },
        body: {
          height: "100%"
        }
      },
      destroyOnHidden: true,
      children: videoId && /* @__PURE__ */ jsx(
        "iframe",
        {
          style: {
            border: "none"
          },
          width: "100%",
          height: "100%",
          src: embedUrl,
          allowFullScreen: true,
          loading: "lazy",
          allow: "autoplay; encrypted-media",
          title: videoId
        }
      )
    }
  );
};
var stdin_default = memo(VideoModal);
export {
  stdin_default as default
};
